/** @file Whether a physical key is currently held (for space-pan, hold-to-switch tools). */
import { keyState } from './_internal/keyState';

/** By KeyboardEvent.code, e.g. `Space`. False while typing in an input (those keys are never tracked). */
export function isHeld(code: string): boolean {
  return keyState.held.has(code);
}
